/* UG outfits row: opens a size sheet for a matching set and adds both items to the cart in one request. */
(function () {
  if (window.customElements.get('ug-outfits')) return;

  var PREF_KEY = 'ugo_size_pref';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function readPref() { try { return window.localStorage.getItem(PREF_KEY) || ''; } catch (e) { return ''; } }
  function writePref(v) { try { window.localStorage.setItem(PREF_KEY, v); } catch (e) { /* ignore */ } }

  class UgOutfits extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.strings = JSON.parse(this.querySelector('[data-ugo-strings]').textContent); } catch (e) { this.strings = {}; }
      this.currency = this.dataset.currency || 'EUR';
      try { this.fmt = new Intl.NumberFormat((this.dataset.locale || document.documentElement.lang || 'en').replace('_', '-'), { style: 'currency', currency: this.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }); } catch (e) { this.fmt = null; }
      this.addEventListener('click', this.onClick.bind(this));
    }

    money(cents) {
      var v = cents / 100;
      if (this.fmt) return this.fmt.format(v);
      return v.toFixed(2) + ' ' + this.currency;
    }

    onClick(event) {
      var btn = event.target.closest('[data-ugo-open]');
      if (!btn) return;
      var card = btn.closest('[data-ugo-card]');
      if (!card) return;
      var data;
      try { data = JSON.parse(card.querySelector('[data-ugo-data]').textContent); } catch (e) { return; }
      this.openSheet(data);
    }

    openSheet(data) {
      var self = this;
      this.data = data;
      this.choice = [null, null];
      var pref = readPref();
      data.items.forEach(function (item, i) {
        var match = item.variants.find(function (v) { return v.t === pref && v.a; });
        if (match) self.choice[i] = match;
      });

      var sheet = document.createElement('div');
      sheet.className = 'ugo-sheet is-open';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      var s = this.strings;
      var itemsHtml = data.items.map(function (item, i) {
        var sizes = item.variants.map(function (v) {
          return '<button type="button" class="ugo-size" data-item="' + i + '" data-id="' + v.id + '" aria-pressed="false"' + (v.a ? '' : ' disabled title="' + (s.sold || '') + '"') + '>' + String(v.t).replace(/</g, '&lt;') + '</button>';
        }).join('');
        return '<div class="ugo-sheet__item"><a href="' + item.url + '"><img src="' + item.image + '" alt="" loading="lazy"></a><div><p class="ugo-sheet__name">' + String(item.title).replace(/</g, '&lt;') + '</p><div class="ugo-sheet__sizes" role="group" aria-label="' + (s.size || '') + '">' + sizes + '</div></div></div>';
      }).join('');
      sheet.innerHTML =
        '<div class="ugo-sheet__scrim" data-close></div>' +
        '<div class="ugo-sheet__panel"><div class="ugo-sheet__top"><p class="ugo-sheet__title">' + (s.sheet || '') + '</p><button type="button" class="ugo-sheet__close" data-close aria-label="Close">&times;</button></div>' +
        itemsHtml +
        '<div class="ugo-sheet__foot"><div class="ugo-sheet__total"><span>' + (s.total || '') + '</span><span><strong data-total></strong><s data-was></s></span></div><p class="ugo-sheet__msg" data-msg role="alert"></p><button type="button" class="ugo-sheet__add" data-add></button></div></div>';
      document.body.appendChild(sheet);
      document.documentElement.classList.add('ugo-lock');
      this.sheet = sheet;

      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]')) { self.closeSheet(); return; }
        var size = e.target.closest('.ugo-size');
        if (size && !size.disabled) {
          var i = Number(size.dataset.item);
          var v = self.data.items[i].variants.find(function (x) { return String(x.id) === size.dataset.id; });
          self.choice[i] = v;
          writePref(v.t);
          self.refresh();
          return;
        }
        if (e.target.closest('[data-add]')) self.add();
      });
      this.onKey = function (e) { if (e.key === 'Escape') self.closeSheet(); };
      document.addEventListener('keydown', this.onKey);
      this.refresh();
    }

    closeSheet() {
      if (this.sheet) { this.sheet.remove(); this.sheet = null; }
      document.documentElement.classList.remove('ugo-lock');
      document.removeEventListener('keydown', this.onKey);
    }

    refresh() {
      var sheet = this.sheet;
      if (!sheet) return;
      var choice = this.choice;
      sheet.querySelectorAll('.ugo-size').forEach(function (b) {
        var i = Number(b.dataset.item);
        b.setAttribute('aria-pressed', choice[i] && String(choice[i].id) === b.dataset.id ? 'true' : 'false');
      });
      var items = this.data.items;
      var price = 0, was = 0;
      items.forEach(function (item, i) {
        var v = choice[i] || item.variants.find(function (x) { return x.a; }) || item.variants[0];
        price += v.p; was += v.c && v.c > v.p ? v.c : v.p;
      });
      sheet.querySelector('[data-total]').textContent = this.money(price);
      sheet.querySelector('[data-was]').textContent = was > price ? this.money(was) : '';
      var ready = !!choice[0] && !!choice[1];
      var add = sheet.querySelector('[data-add]');
      add.disabled = !ready || this.busy;
      add.textContent = ready ? this.strings.add : this.strings.pick;
    }

    async add() {
      if (this.busy || !this.choice[0] || !this.choice[1]) return;
      this.busy = true;
      this.refresh();
      var msg = this.sheet.querySelector('[data-msg]');
      msg.textContent = '';
      var tag = this.data.items.map(function (i) { return i.id; }).join('+');
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: this.choice.map(function (v) { return { id: v.id, quantity: 1, properties: { _ug_outfit: tag } }; }),
            sections: 'variant-added',
            sections_url: window.location.pathname
          })
        });
        var result = await res.json();
        if (!res.ok) throw new Error(result.description || result.message || 'error');
        var fresh = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
        fresh.sections = result.sections;
        this.closeSheet();
        this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items || [], cart: fresh } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: fresh } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var drawer = document.querySelector('cart-drawer');
        if (drawer) setTimeout(function () { if (!drawer.hasAttribute('open')) drawer.setAttribute('open', ''); }, 350);
      } catch (error) {
        msg.textContent = (error && error.message && !/^error$/.test(error.message) ? error.message : this.strings.error) || '';
        this.busy = false;
        this.refresh();
        return;
      }
      this.busy = false;
    }
  }

  customElements.define('ug-outfits', UgOutfits);
})();
